module.exports = __webpack_public_path__ + "static/media/arrow-solid.91b44509.svg";